"use client";

import Link from "next/link";

import { useHeaderAccount } from "~/components/patterns/use-header-account";
import { cn } from "~/lib/utils";

export function PublicAccountLink({ light = false }: { light?: boolean }) {
  const account = useHeaderAccount();

  return (
    <Link
      href={account.isAuthenticated ? "/app/dashboard" : "/app/login"}
      className={cn(
        "hidden text-sm font-medium hover:text-brand lg:inline",
        light
          ? "text-white hover:text-editorial-paper-contrast"
          : "text-foreground",
      )}
    >
      {account.isAuthenticated ? account.dashboardLabel : "Prijava"}
    </Link>
  );
}
